<head>
  <meta name="viewport" content="initial-scale=1.0, user-scalable=no">
</head>
<div class="container">
  <!--id section-->
  <div class="row flexContainer btnRow">
      <div class="col-sm-3">
          <div class="row">
              <div class="col-sm-12">
                  <h5 *ngIf="requestDetail.source |isWorkorderRequest; else isServiceRequest1">{{'components.sheet.workorderRequest' | translate}}</h5>
                  <ng-template #isServiceRequest1>
                      <h5>{{'components.sheet.serviceRequest' | translate}}</h5>
                  </ng-template>
              </div>
          </div>
          <div class="row">
              <div class="col-sm-12"><b>{{'components.sheet.number' | translate}} {{requestDetail.requestNumber}}</b></div>
          </div>
      </div>
      <div class="col-sm-3">
          <button class="btn btnRound" (click)="backToRequestList()"><i class="fa fa-arrow-circle-left" aria-hidden="true"></i> {{'components.sheet.back' | translate}}</button>
      </div>
      <div *ngIf="requestDetail.source |isWorkorderRequest" class="col-sm-3">
          <button class="btn btnRound" (click)="closeWorkorder(requestDetail.id)"><i class="fa fa-times" aria-hidden="true"></i> {{'components.sheet.closeWorkorder' | translate}}</button>
      </div>
      <div class="col-sm-3">
          <button class="btn btnFilled" (click)="editRequest(requestDetail.id)"><i class="fa fa-pencil-square-o" aria-hidden="true"></i> {{'components.requestComponent.actions' | translate}}</button>
      </div>
  </div>
  <hr class="separator" />
  <!--general info section-->
  <div >
      <div class="col-sm-12 text-center">
          <table>
              <tr>
                  <td>
                      <div>
                          <label style="display:block" for="staticMapId">&nbsp;</label>
                          <div id="staticMapId">La carte statique</div>
                      </div>
                  </td>
                  <td>
                      <div style="margin-left:3px" *ngIf="citizenImages?.length > 0">
                          <label style="display:block" [for]="clientFirstPhoto">{{'components.editRequest.photosCitoyen' | translate}}</label>
                          <img class="documentPhotoStyle" id="clientFirstPhoto" [alt]="clientImgAltMessage | translate" [src]="citizenImages[0].previewImageSrc" />
                      </div>
                  </td>
                  <td>
                    <div style="margin-left:3px" *ngIf="foremanImages?.length > 0">
                      <label style="display:block" [for]="foremanCarrousel">{{'components.editRequest.photosContremaitre' | translate}}</label>
                      <div id="foremanCarrousel">
                          <p-galleria [(value)]="foremanImages" [responsiveOptions]="responsiveOptions" [containerStyle]="{'max-width': '640px'}" [numVisible]="2"> 
                              <ng-template pTemplate="item" let-item>
                                  <img [src]="item.previewImageSrc" style="width: 100%;" />
                              </ng-template>
                              <ng-template pTemplate="thumbnail" let-item>
                                  <div class="p-grid p-nogutter p-justify-center">
                                      <img [src]="item.previewImageSrc" style="width: 30%;" />
                                  </div>
                              </ng-template>
                          </p-galleria>
                      </div>
                    </div>
                  </td>
              </tr>
          </table>
      </div>
      <div class="row title">
          <div class="col-sm-12">{{'components.sheet.activity' | translate}}</div>
      </div>
      <div class="row value">
          <div class="col-sm-12"><img class="srv-img" src="{{iconService.getIconName(requestDetail.service.code)}}" />{{requestDetail.service.name}}</div>
      </div>
      <div class="row title">
          <div class="col-sm-12">{{'components.sheet.status' | translate}}</div>
      </div>
      <div class="row value">
          <div class="col-sm-12"><i class="fa fa-hourglass-half" aria-hidden="true"></i> {{requestDetail.status?.name}}
              <span class="valueRelaunched" *ngIf="requestDetail.isRelaunched"> - {{ 'components.requestComponent.relaunched' | translate }}</span>
              <span class="valueRelaunched" *ngIf="requestDetail.isRelaunched && requestDetail.isReactivated">&#47;</span>
              <span class="valueRelaunched" *ngIf="requestDetail.isReactivated">{{ 'components.requestComponent.reactivated' | translate }}</span>
          </div>
      </div>
      <div class="row title">
          <div class="col-sm-12">{{'components.sheet.completeDate' | translate}}</div>
      </div>
      <div class="row value">
          <div class="col-sm-12">
              <i class="fa fa-calendar-o" aria-hidden="true"></i> {{requestDetail.estimatedCompletionDate | date: 'dd MMMM y HH:mm'}}
              <span class="valueImportant" *ngIf="hasDelayOver1Day">- {{'components.requestComponent.delayed' | translate }} {{  delayDays }} {{'components.requestComponent.days' | translate }}</span>
              <span class="valueImportant" *ngIf="hasDelayWithin1Day">- {{'components.requestComponent.delayedWithin1Day' | translate }}</span>
          </div>
      </div>
      <div class="row title">
          <div class="col-sm-12">{{'components.sheet.address' | translate}}</div>
      </div>
      <div class="row value">
          <div class="col-sm-12"><i class="fa fa-map-marker" aria-hidden="true"></i> {{requestDetail.formattedAddress}}</div>
      </div>
      <div class="row title">
          <div class="col-sm-12">{{'components.sheet.clientComment' | translate}}</div>
      </div>
      <div class="row value">
          <div class="col-sm-12">
              <i class="fa fa-comment" aria-hidden="true"></i>
              <span *ngIf="requestDetail.clients?.length">{{requestDetail.clients[0].comment}} - {{requestDetail.clients[0].name}} - {{requestDetail.clients[0].creationDatetime | date:'dd MMMM y HH:mm'}}</span>
          </div>
      </div>
      <hr class="separator" />
      <ng-container *ngIf="requestDetail.source === requestSourceTypeEnum.workorderRequest">
          <!--history section-->
          <div class="row">
              <div class="col-sm-12 sectionTitle">
                  {{'components.sheet.requestHistory' | translate}}
              </div>
          </div>
          <div class="row title">
              <div class="col-sm-12">{{'components.sheet.createDate' | translate}}</div>
          </div>
          <div class="row value">
              <div class="col-sm-12"><i class="fa fa-calendar-o" aria-hidden="true"></i> {{requestDetail.creationDatetime | date:'dd MMMM y HH:mm'}}</div>
          </div>
          <div class="row title">
              <div class="col-sm-12">{{'components.sheet.requestObject' | translate}}</div>
          </div>
          <div class="row value">
              <div class="col-sm-12"><i class="fa fa-tag" aria-hidden="true"></i> {{requestDetail.description}}</div>
          </div>
          <div class="row title">
              <div class="col-sm-12">{{'components.sheet.statusHistory' | translate}}</div>
          </div>
          <div class="container valueWithBorder">
              <div class="col-sm-12 value" *ngFor="let event of (events$ | async)">
                  <div *ngIf="event.statusCode">
                      <i class="fa fa-hourglass-half" aria-hidden="true"></i>
                      <span>{{event.statusName}}</span>
                      <span *ngIf="event.statusDate"> - {{event.statusDate | date:'dd MMMM y HH:mm'}}</span>
                      <span *ngIf="event.reason"> - Raison: {{event.reason}}</span>
                      <span *ngIf="event?.userLastName"> - {{event.userLastName}}</span><span *ngIf="event?.userFirstName">, {{event.userFirstName}}</span>
                  </div>
              </div>
          </div>
      </ng-container>
      <hr class="separator" />
      <ng-container>
          <div class="row title">
              <div class="col-sm-12">{{'components.sheet.internalComments' | translate}}</div>
          </div>

          <div class="container valueWithBorder">
            <div class="col-sm-12 value" *ngFor="let event of (events$ | async)">
                <div *ngIf="event.internalComment">
                    <i class="fa fa-comment" aria-hidden="true"></i>
                    <span *ngIf="event.creationDate">{{event.creationDate | date:'dd MMMM y HH:mm'}}</span>
                    <span> - {{event.internalComment}}</span>
                    <span *ngIf="event?.userLastName"> - {{event.userLastName}}</span><span *ngIf="event?.userFirstName">, {{event.userFirstName}}</span>
                </div>
            </div>
          </div>
          <hr class="separator" />
      </ng-container>
      <!--manager section-->
      <div class="row">
          <div class="col-sm-6 sectionTitle">
              <i class="fa fa-caret-right" aria-hidden="true" *ngIf="btnManager.collapse"></i>
              <i class="fa fa-caret-down" aria-hidden="true" *ngIf="!btnManager.collapse"></i> {{'components.sheet.manager' | translate}}
          </div>
          <div class="col-sm-3 col-sm-offset-3">
              <app-dropdown-button [defaultCollapse]="true" #btnManager></app-dropdown-button>
          </div>
      </div>
      <div class="container" *ngIf="!btnManager.collapse">
          <div class="row">
              <div class="col-sm-6">
                  <div class="row title">
                      <div class="col-sm-12">{{'components.sheet.requestOrigin' | translate}}</div>
                  </div>
                  <div class="row value">
                      <div class="col-sm-12"><i class="fa fa-user" aria-hidden="true"></i> {{requestDetail.responsible?.userName}}</div>
                  </div>
              </div>
              <div class="col-sm-6">
                  <div class="row title">
                      <div class="col-sm-12">{{'components.sheet.managerGroup' | translate}}</div>
                  </div>
                  <div class="row value">
                      <div class="col-sm-12"><i class="fa fa-users" aria-hidden="true"></i> {{requestDetail.responsible?.groupName}}</div>
                  </div>
              </div>
          </div>
          <div class="row title">
              <div class="col-sm-12">{{'components.sheet.district' | translate}}</div>
          </div>
          <div class="row value">
              <div class="col-sm-12"><i class="fa fa-building" aria-hidden="true"></i> {{requestDetail.borough?.name}}</div>
          </div>
      </div>
      <hr class="separator" />
      <!--client section-->
      <div class="row">
          <div class="col-sm-6 sectionTitle">
              <i class="fa fa-caret-right" aria-hidden="true" *ngIf="btnClient.collapse"></i>
              <i class="fa fa-caret-down" aria-hidden="true" *ngIf="!btnClient.collapse"></i> {{'components.sheet.client' | translate}}
          </div>
          <div class="col-sm-3 col-sm-offset-3">
              <app-dropdown-button [defaultCollapse]="true" #btnClient></app-dropdown-button>
          </div>
      </div>
      <div class="container" *ngIf="!btnClient.collapse">
          <div class="row title">
              <div class="col-sm-12">{{'components.sheet.clientsInfo' | translate}}</div>
          </div>
          <div class="container valueWithBorder">
              <div *ngFor="let client of requestDetail.clients; let isLast=last">
                  <div class="row valueList">
                      <div class="col-sm-4 "><i class="fa fa-user" aria-hidden="true"></i> {{client.name}}</div>
                      <div class="col-sm-8 "><i class="fa fa-phone" aria-hidden="true"></i>
                          <span *ngFor="let telephone of client.telephones">{{telephone.type}}: {{telephone.number | phone}} {{telephone.post}} </span>
                      </div>
                  </div>
                  <div class="row valueList">
                      <div class="col-sm-8 col-sm-offset-4 "><i class="fa fa-map-marker" aria-hidden="true"></i> {{client.address}}</div>
                  </div>
                  <hr class="separator" *ngIf="!isLast" />
              </div>
          </div>
          <div class="row title">
              <div class="col-sm-12">{{'components.sheet.clientComments' | translate}}</div>
          </div>
          <div class="container valueWithBorder">
              <div class="col-sm-12 value" *ngFor="let client of requestDetail.clients">
                  <i class="fa fa-comment" aria-hidden="true"></i>
                  <span *ngIf="client.creationDatetime">{{client.creationDatetime | date:'dd MMMM y HH:mm'}}</span>
                  <span> - {{client.comment}}</span>
                  <span *ngIf="client.name"> - {{client.name}}</span>
              </div>
          </div>
      </div>
      <hr class="separator" />
      <div class="row lastRow btnRow">
          <div class="col-sm-4">
              <button class="btn btnRound" (click)="backToRequestList()"><i class="fa fa-arrow-circle-left" aria-hidden="true"></i> {{'components.sheet.back' | translate}}</button>
          </div>
          <div *ngIf="requestDetail.source |isWorkorderRequest" class="col-sm-4">
              <button class="btn btnRound" (click)="closeWorkorder(requestDetail.id)"><i class="fa fa-times" aria-hidden="true"></i> {{'components.sheet.closeWorkorder' | translate}}</button>
          </div>
          <div class="col-sm-4">
              <button class="btn btnFilled" (click)="editRequest(requestDetail.id)"><i class="fa fa-pencil-square-o" aria-hidden="true"></i> {{'components.requestComponent.actions' | translate}}</button>
          </div>
      </div>
  </div>